import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <Navbar />
      <main className="flex-1 flex items-center justify-center px-4 pt-24 pb-16">
        <div className="max-w-xl text-center">
          <p className="text-secondary-500 text-xs uppercase tracking-[0.3em] mb-4 font-semibold">Error 404</p>
          <h1 className="font-heading text-3xl md:text-5xl font-semibold text-foreground-950 leading-tight">
            No encontramos esta página
          </h1>
          <p className="text-sm md:text-base text-foreground-600 mt-5 leading-relaxed">
            Es posible que el enlace haya cambiado o que la dirección esté incompleta. Puede volver al inicio o escribirnos directamente para orientarle.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-8">
            <Link to="/" className="w-full sm:w-auto bg-primary-500 hover:bg-primary-600 text-foreground-50 text-sm font-semibold px-7 py-3 rounded-md whitespace-nowrap cursor-pointer">
              Volver al inicio
            </Link>
            <a href="mailto:leferasa@hotmail.com" className="w-full sm:w-auto border border-background-300 text-foreground-800 hover:bg-background-100 text-sm px-7 py-3 rounded-md whitespace-nowrap cursor-pointer flex items-center justify-center gap-2">
              <i className="ri-mail-line"></i> Escribir al bufete
            </a>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}